export function slugifyBrandName(name) {
  const slug = String(name || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

  return slug || 'untitled';
}

export function buildBrandGuidelineSlugMap(brandGuidelines) {
  const sorted = [...brandGuidelines].sort((a, b) => Number(a.id) - Number(b.id));
  const baseSlugCounts = {};
  const slugById = {};

  sorted.forEach((guideline) => {
    const baseSlug = slugifyBrandName(guideline.brand_name || guideline.name || '');
    const count = (baseSlugCounts[baseSlug] || 0) + 1;
    baseSlugCounts[baseSlug] = count;
    slugById[guideline.id] = count === 1 ? baseSlug : `${baseSlug}_${count}`;
  });

  return slugById;
}

export function getBrandGuidelineSlug(guideline, brandGuidelines) {
  if (!guideline?.id) {
    return null;
  }

  const slugMap = buildBrandGuidelineSlugMap(brandGuidelines);
  return slugMap[guideline.id] || slugifyBrandName(guideline.brand_name || guideline.name || '');
}

export function findBrandGuidelineBySlug(brandGuidelines, slug) {
  if (!slug) {
    return null;
  }

  const slugMap = buildBrandGuidelineSlugMap(brandGuidelines);
  return brandGuidelines.find((guideline) => slugMap[guideline.id] === slug) || null;
}

export function parseLibraryTabParam(tab) {
  if (!tab) {
    return { tabId: null, brandSlug: null };
  }

  const slashIndex = tab.indexOf('/');

  if (slashIndex === -1) {
    return { tabId: tab, brandSlug: null };
  }

  return {
    tabId: tab.slice(0, slashIndex),
    brandSlug: tab.slice(slashIndex + 1) || null,
  };
}

export function buildLibraryTabParam(tabId, brandSlug = null) {
  if (brandSlug) {
    return `${tabId}/${brandSlug}`;
  }

  return tabId;
}
